import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import GetPrice from "../Functions/GetPrice";
import {
  CapitalizeAllWords,
  convertToPersian,
  NumToFa,
  RangeToFa,
  capitalizeFirstLetters,
} from "../Functions/TextTransform";
import { DebounceInput } from "react-debounce-input";
import OverlayContainer from "../Components/OverlayContainer";
import {
  Accordion,
  AccordionContext,
  useAccordionButton,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import NumberToPersianWord from "number_to_persian_word";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import InnerImageZoom from "react-inner-image-zoom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useMediaQuery } from "react-responsive";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";
import RenderSideCart from "../Components/RenderSideCart";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import StaticMeasureHelps from "../Static Files/StaticMeasureHelps";
import RequestFabricSwatches from "../Components/RequestFabricSwatches";
import WaitlistModalOneCurtain from "../Components/Modal/WaitlistModalOneCurtain";
import WaitlistSuccessModalOneCurtain from "../Components/Modal/WaitlistSuccessModalOneCurtain";
import { ShowLogin2Modal } from "../Actions/types";
import QtyCountFabric from "../Components/QtyCountFabric";
import { baseURLCats, baseURLCatProduct, baseURLAddProduct, baseURLSaveProduct, baseURLFreeShipping, baseURLGetFavorites, baseURLDeleteFavorite, imgUrl, baseURLGetPrice, baseURLJoinWaitingList } from "../config/api";
// اگر قرار شد UNLINED نشون نده خط ۳۹ از کامنت خارج بشه و ۴۰ کامنت بشه.
// const UNLINED_LINING_TYPE_ID = 6001;
const UNLINED_LINING_TYPE_ID = 6006;

function getOneCurtainSelectionState(
  activeProduct,
  catProducts,
  isColorSelected,
  isSizeSelected,
  isLiningSelected
) {
  const isOneCurtainProduct = activeProduct?.["ProductGroupId"] === "100201";
  const defaultState = {
    isOneCurtainProduct,
    hasSingleSizeForColor: false,
    singleSizeProduct: null,
    isAllUnlined: false,
    hasSingleLiningType: false,
    singleLiningProduct: null,
    needsLiningSelection: false,
    needsSizeSelection: false,
    isSizeRequirementMet: isSizeSelected,
    isLiningRequirementMet: isLiningSelected,
    isProductConfigurationComplete: false,
    availableColorSizes: [],
  };

  if (!isOneCurtainProduct || !activeProduct?.["ColorId"] || !catProducts?.length) {
    return defaultState;
  }

  const colorProducts = catProducts.filter(
    (p) =>
      p["SewingModelId"] === activeProduct["SewingModelId"] &&
      p["ColorId"] === activeProduct["ColorId"]
  );
  const availableColorSizes = [
    ...new Set(colorProducts.map((p) => p["ProductSizeEnName"]).filter(Boolean)),
  ];
  const colorLiningTypeIds = [
    ...new Set(colorProducts.map((p) => p["LiningTypeId"]).filter((id) => id != null)),
  ];

  const hasSingleSizeForColor = availableColorSizes.length === 1;
  const singleSizeProduct = hasSingleSizeForColor ? colorProducts[0] : null;
  const isAllUnlined =
    colorLiningTypeIds.length === 1 && colorLiningTypeIds[0] === UNLINED_LINING_TYPE_ID;
  const hasSingleLiningType = colorLiningTypeIds.length === 1 && !isAllUnlined;
  const singleLiningProduct = hasSingleLiningType
    ? colorProducts.find((p) => p["LiningTypeId"] === colorLiningTypeIds[0])
    : null;
  const needsLiningSelection = colorLiningTypeIds.length > 1;
  const needsSizeSelection = availableColorSizes.length > 1;
  const isSizeRequirementMet = isSizeSelected || hasSingleSizeForColor;
  const isLiningRequirementMet = isLiningSelected || isAllUnlined || hasSingleLiningType;

  return {
    isOneCurtainProduct,
    hasSingleSizeForColor,
    singleSizeProduct,
    isAllUnlined,
    hasSingleLiningType,
    singleLiningProduct,
    needsLiningSelection,
    needsSizeSelection,
    isSizeRequirementMet,
    isLiningRequirementMet,
    isProductConfigurationComplete:
      isColorSelected && isSizeRequirementMet && isLiningRequirementMet,
    availableColorSizes,
  };
}

function ReadyMyProduct() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const { catID } = useParams();
  const inputs = useRef({});
  const { productID } = useParams();
  const { designID } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isLoggedIn, sideCartPrice, cartUpdated, mainCart } = useSelector((state) => state.auth);
  const [completePageState, setCompletePageState] = useState(searchParams.get("C"));
  const [activeIndex, setActiveIndex] = useState(0);
  const [isWidthSelected, setIsWidthSelected] = useState(false);
  const [isPriceSelected, setIsPriceSelected] = useState(false);
  const [modals, setModals] = useState({});
  const [sideCartObjects, setSideCartObjects] = useState({});
  const [sideCartProductTotal, setSideCartProductTotal] = useState(0);
  const [sideCartInstallPrice, setSideCartInstallPrice] = useState(0);
  const [sideCartTransportPrice, setSideCartTransportPrice] = useState(0);
  const [sideCartHasSwatches, setSideCartHasSwatches] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const splideRef = useRef(null);
  const [catObject, setCatObject] = useState({});
  const [productAwaitingLogin, setProductAwaitingLogin] = useState([]);
  const [catProducts, setCatProducts] = useState([]);
  const [userFavorites, setUserFavorites] = useState([]);
  const [designProducts, setDesignProducts] = useState({});
  const [activeProduct, setActiveProduct] = useState({});
  const [splidesList, setSplidesList] = useState([]);
  const [slidesList, setSlidesList] = useState([]);
  const [colorsList, setColorsList] = useState([]);
  const [sizesList, setSizesList] = useState([]);
  const [priceActive, setPriceActive] = useState(null);
  const [widthList, setWidthList] = useState([]);
  const [lengthList, setLengthList] = useState([]);
  const [controlsList, setControlsList] = useState([]);
  const [liningsList, setLiningsList] = useState([]);
  const [IsDiscPriceSelected, setIsDiscPriceSelected] = useState(false);
  const [isPageComplete, setIsPageComplete] = useState(completePageState === "1");
  const [isColorSelected, setIsColorSelected] = useState(true);
  const [isSizeSelected, setIsSizeSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] === "Ready-Made-Shade"
  );
  const [isProductActive, setIsProductActive] = useState(null);
  const [isLengthSelected, setIsLengthSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] !== "Ready-Made-Shade"
  );
  const [isControlSelected, setIsControlSelected] = useState(
    completePageState === "1" || location.pathname.split("/")[2] !== "Ready-Made-Shade"
  );
  const [isLiningSelected, setIsLiningSelected] = useState(completePageState === "1");
  const [colorError, setColorError] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [liningError, setLiningError] = useState(false);
  const [qty, setQty] = useState(1);
  const [addingLoading, setAddingLoading] = useState(false);
  const [savingLoading, setSavingLoading] = useState(false);
  const [removingLoading, setRemovingLoading] = useState(false);
  const [toastSave, setToastSave] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [showWaitlistEmail, setShowWaitlistEmail] = useState(false);
  const [waitlistEmail, setWaitlistEmail] = useState("");
  const [waitlistRegisteredEmail, setWaitlistRegisteredEmail] = useState("");
  const [waitlistSubmitProductId, setWaitlistSubmitProductId] = useState(null);
  const [waitlistEmailError, setWaitlistEmailError] = useState("");
  const [waitlistMessageType, setWaitlistMessageType] = useState("error");
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const waitlistMessageTimeoutRef = useRef(null);
  const [productGroupId, setProductGroupId] = useState(null);
  const [width, setWidth] = useState(undefined);
  const [minDiscountedPrice, setMinDiscountedPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [minDiscountedPrice2, setMinDiscountedPrice2] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  // Which of size/lining was chosen first after color. That choice stays limited only by color.
  const [secondSelection, setSecondSelection] = useState(null);

  const stockQty = Number(activeProduct["StockQty"]) || 0;
  const maxOrderableQty = Number(activeProduct["MaxOrderableQty"]) || 10;
  const fabricSteps = activeProduct["UnitId"] === 1 ? 0.5 : 1;
  const isSoldOut = stockQty === 0 && activeProduct["OnBasket"] === false;
  const isWaitlist = stockQty === 0 && activeProduct["OnBasket"] === true;
  const fabricMaxQty =
    stockQty > 0 ? Math.round((stockQty + fabricSteps) * 100) / 100 : maxOrderableQty;
  const isOverStock = stockQty > 0 && !isSoldOut && !isWaitlist && qty > stockQty;

  const validateWaitlistEmail = (email) =>
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/.test(
      email
    );

  const showWaitlistMessage = (message, type = "error") => {
    if (waitlistMessageTimeoutRef.current) {
      clearTimeout(waitlistMessageTimeoutRef.current);
    }
    setWaitlistMessageType(type);
    setWaitlistEmailError(message);
    waitlistMessageTimeoutRef.current = setTimeout(() => {
      setWaitlistEmailError("");
      waitlistMessageTimeoutRef.current = null;
    }, 5000);
  };

  const isAlreadyRegisteredMessage = (message = "") =>
    /قبلاً|قبلا|already registered|already|لیست انتظار ثبت/i.test(message);

  useEffect(() => {
    return () => {
      if (waitlistMessageTimeoutRef.current) {
        clearTimeout(waitlistMessageTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setShowWaitlistEmail(false);
    setWaitlistEmail("");
    setWaitlistEmailError("");
    setWaitlistMessageType("error");
    if (waitlistMessageTimeoutRef.current) {
      clearTimeout(waitlistMessageTimeoutRef.current);
      waitlistMessageTimeoutRef.current = null;
    }
    const stock = Number(activeProduct["StockQty"]) || 0;
    const steps = activeProduct["UnitId"] === 1 ? 0.5 : 1;
    const nextMax =
      stock > 0
        ? Math.round((stock + steps) * 100) / 100
        : Number(activeProduct["MaxOrderableQty"]) || 10;
    setQty((prev) => Math.min(Math.max(prev, 1), nextMax > 0 ? nextMax : 1));
  }, [activeProduct["ProductId"]]);

  const getCatProducts = () => {
    if (searchParams.get("Product") && searchParams.get("Product") !== "") {
      axios
        .get(baseURLCats, {
          params: {
            pageName: catID,
            // apiKey: window.$apikey
          },
        })
        .then((response) => {
          setCatObject(response.data || {});
        })
        .catch((err) => {
          console.log(err);
          navigate("/" + pageLanguage);
        });
      // console.log(defDesign);
      axios
        .get(baseURLCatProduct, {
          params: {
            groupId: productID,
            designs: designID,
            // apiKey: window.$apikey
          },
          headers: authHeader()
        })
        .then((response) => {
          if (response.data && response.data["Products"]?.length) {
            setCatProducts(response.data["Products"]);
          } else {
            setCatProducts({});
            setDesignProducts({});
            navigate("/" + pageLanguage);
          }
        })
        .catch((err) => {
          console.log(err);
          navigate("/" + pageLanguage);
        });
    } else {
      navigate("/" + pageLanguage);
    }
  };

  function getFavorites() {
    axios
      .get(baseURLGetFavorites, {
        headers: authHeader(),
      })
      .then((response) => {
        if (isLoggedIn && !response.data?.length && productAwaitingLogin.length) {
          saveProduct(productAwaitingLogin[0], productAwaitingLogin[1], true);
          setProductAwaitingLogin([]);
        }
        setUserFavorites(response.data || []);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getFavorites();
            } else {
              // navigate("/" + pageLanguage);
            }
          });
        } else {
          setUserFavorites([]);
        }
      });
  }

  function modalHandleClose(modalName) {
    setModals((prev) => ({
      ...prev,
      [modalName]: false,
    }));
  }

  function modalHandleShow(modalName) {
    setModals((prev) => ({
      ...prev,
      [modalName]: true,
    }));
  }

  function openWaitlistModal() {
    setSizeError(false);
    setLiningError(false);
    setWaitlistSubmitProductId(activeProduct["ProductId"]);
    modalHandleShow("waitlist");
  }

  function handleWaitlistProductChange(productId) {
    if (!productId) {
      return;
    }
    setWaitlistSubmitProductId(productId);
    setSearchParams("?Product=" + productId);
  }

  function getActiveColorProducts() {
    let tempActiveProduct =
      catProducts.find((obj) => obj["ProductId"] === searchParams.get("Product")) || {};

    if (Object.keys(tempActiveProduct).length === 0) {
      navigate("/" + pageLanguage);
    } else {
      let temp = {};
      let promiseArr = [];
      catProducts.forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          if (
            temp[obj["ColorId"]] === "" ||
            temp[obj["ColorId"]] === undefined ||
            temp[obj["ColorId"]] === null ||
            temp[obj["ColorId"]].length === 0
          ) {
            temp[obj["ColorId"]] = [];
          }
          temp[obj["ColorId"]].push(obj);
          resolve();
        });
      });

      Promise.all(promiseArr).then(() => {
        setDesignProducts(temp);

        setActiveProduct(tempActiveProduct);
      });
    }
  }

  const [selectedItems, setSelectedItems] = useState({
    size: null,
    color: null,
  });

  function renderPageContent() {
    if (Object.keys(designProducts).length) {
      let temp = [];
      let temp2 = {};
      let temp3 = [];
      let temp4 = [];
      let temp5 = {};
      let temp6 = {};
      let temp7 = {};
      let temp8 = {};
      let promiseArr = [];
      Object.keys(designProducts).forEach((key, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let ProductId = designProducts[key][0]["ProductId"];
          let SewingModelId = designProducts[key][0]["SewingModelId"];
          setProductGroupId(designProducts[key][0]["ProductGroupId"]);

          let ColorEnName = CapitalizeAllWords(designProducts[key][0]["ColorEnName"]);
          let ColorName = convertToPersian(designProducts[key][0]["ColorName"]);
          let ColorPhotoPath =
            designProducts[key][0]["Photos"].find((obj) => obj.PhotoTypeId === 4709)?.PhotoUrl ||
            "";

          let isActiveColor = designProducts[key]
            .map(function(obj) {
              return obj["ProductId"];
            })
            .filter((n) => n)
            .includes(searchParams.get("Product"));

          // When size and/or lining is selected, mark colors that lack that combo
          let selectedSizeForColorCheck = isSizeSelected
            ? selectedSize || activeProduct["ProductSizeEnName"]
            : null;
          let selectedLiningForColorCheck = isLiningSelected
            ? activeProduct["LiningTypeId"]
            : null;
          let isColorAvailableForSelection = true;
          const isOneCurtainColorGroup =
            designProducts[key][0]["ProductGroupId"] === "100201";
          if (
            isOneCurtainColorGroup &&
            (selectedSizeForColorCheck || selectedLiningForColorCheck != null)
          ) {
            isColorAvailableForSelection = designProducts[key].some((p) => {
              const matchesSize =
                !selectedSizeForColorCheck ||
                p["ProductSizeEnName"] === selectedSizeForColorCheck;
              const matchesLining =
                selectedLiningForColorCheck == null ||
                p["LiningTypeId"] === selectedLiningForColorCheck;
              return matchesSize && matchesLining;
            });
          }
          const isColorFullyOutOfStock =
            isOneCurtainColorGroup &&
            designProducts[key].length > 0 &&
            !designProducts[key].some((p) => Number(p["StockQty"]) > 0);

          temp.push(
            <li
              key={"color" + ProductId + index}
              className={`rmd_info_colors_list_item Accessories_List_item_colors_list_item ${
                isColorSelected && isActiveColor ? "colorSelected" : ""
              } ${!isColorAvailableForSelection || isColorFullyOutOfStock ? "crossed" : ""}`}
              onClick={() => {
                if (!isColorSelected) {
                  setIsColorSelected(true);
                }
                setSearchParams("?Product=" + ProductId);
                if (designProducts[key][0]["ProductGroupId"] === "100201") {
                  setSelectedSize(null);
                  setIsSizeSelected(false);
                  setIsLiningSelected(false);
                  setSecondSelection(null);
                  setIsPriceSelected(false);
                  setIsDiscPriceSelected(false);
                  setPriceActive(null);
                  setSelectedItems((prev) => ({ ...prev, size: null }));
                  setSizeError(false);
                  setLiningError(false);
                } else {
                  setPriceActive(activeProduct["Price"]);
                  selectedItems.size = null;
                  setSelectedSize(null);
                  setIsPriceSelected(true);
                  setIsDiscPriceSelected(true);
                  const width = activeProduct["Width"];
                  const length = activeProduct["Length"];
                  const isSizeAvailable = designProducts[key].some(
                    (obj) => obj["Width"] === width && obj["Length"] === length
                  );
                  if (!isSizeAvailable) {
                    setSizeError(true);
                    setSelectedSize(null);
                    setIsSizeSelected(false);
                  }
                }
              }}
            >
              <OverlayContainer
                classNames="Accessories_List_item_color"
                placement="middle"
                children={
                  <div
                    className="Accessories_List_item_colors_list_item_overlay"
                    style={{
                      background:
                        `transparent url(${imgUrl(ColorPhotoPath.trim())}) no-repeat`,
                    }}
                  />
                }
                component={
                  <div className="Accessories_List_item_color_container">
                    <p className="Accessories_List_item_color_text">
                      {pageLanguage === "en" ? ColorEnName : ColorName}
                    </p>
                  </div>
                }
              />
            </li>
          );

          let promiseArr2 = [];
          designProducts[key].forEach((obj, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              let isActiveProduct = obj["ProductId"] === searchParams.get("Product");

              let sizeText = obj["ProductSizeEnName"];
              let sizeTextFa = obj["ProductSizeName"];

              const handleItemClick = (type, value) => {
                setSelectedItems((prev) => ({
                  ...prev,
                  [type]: value,
                }));
              };

              const isOneCurtainGroup =
                designProducts[key][0]["ProductGroupId"] === "100201";

              // One-curtain sizes are built per selected color after the product loop
              if (!isOneCurtainGroup) {
                if (temp2[sizeText] === undefined || isActiveProduct) {
                  temp2[sizeText] = (
                    <li
                      key={"size" + ProductId + i}
                      className={`rmd_info_btn_list_item ${
                        selectedItems.size === sizeText ? "btnSelected" : ""
                      } ${isActiveColor ? "" : "crossed"}`}
                    >
                      <button
                        className="btn"
                        onClick={() => {
                          setSelectedSize(sizeText);
                          handleItemClick("size", sizeText);
                          setIsProductActive(obj["ProductId"]);
                          setPriceActive(obj["Price"]);
                        }}
                      >
                        {pageLanguage === "fa" ? sizeTextFa : sizeText}
                      </button>
                    </li>
                  );
                }
              }

              let isActiveLining = obj["ProductId"] === searchParams.get("Product");
              if (obj["LiningTypeId"] != null && !isOneCurtainGroup) {
                let liningTypeId = obj["LiningTypeId"];
                if (temp5[liningTypeId] === undefined || isActiveLining) {
                  temp5[liningTypeId] = (
                    <li
                      key={"lining" + ProductId + i}
                      className={`rmd_info_btn_list_item ${
                        isActiveColor
                          ? isLiningSelected &&
                            activeProduct["LiningTypeId"] === liningTypeId
                            ? "btnSelected"
                            : ""
                          : "crossed"
                      }`}
                    >
                      <button
                        className="btn"
                        onClick={() => {
                          if (!isLiningSelected) {
                            setIsLiningSelected(true);
                          }
                          setSearchParams("?Product=" + obj["ProductId"]);
                        }}
                      >
                        {pageLanguage === "fa"
                          ? obj["LiningTypeName"]
                          : obj["LiningTypeEnName"]}
                      </button>
                    </li>
                  );
                }
              }

              let widthText = obj["Width"];
              if (temp6[widthText] === undefined || isActiveProduct) {
                temp6[widthText] = (
                  <li
                    key={"Width" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isWidthSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className="btn"
                      onClick={() => {
                        if (!isWidthSelected) {
                          setIsWidthSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {NumToFa(widthText + t("Measurements CM"), pageLanguage)}
                    </button>
                  </li>
                );
              }

              let lengthText = obj["Length"];

              if (temp7[lengthText] === undefined || isActiveProduct) {
                temp7[lengthText] = (
                  <li
                    key={"Length" + ProductId + i}
                    className={`rmd_info_btn_list_item ${
                      isActiveColor
                        ? isLengthSelected && isActiveProduct
                          ? "btnSelected"
                          : ""
                        : "crossed"
                    }`}
                  >
                    <button
                      className="btn"
                      onClick={() => {
                        if (!isLengthSelected) {
                          setIsLengthSelected(true);
                        }
                        setSearchParams("?Product=" + obj["ProductId"]);
                      }}
                    >
                      {NumToFa(lengthText + t("Measurements CM"), pageLanguage)}
                    </button>
                  </li>
                );
              }
              let controlText = obj["ControlPosition"] ? "Right" : "Left";
              let controlImg = undefined;
              if (temp8[controlText] === undefined || isActiveColor) {
                if (SewingModelId === "0303") {
                  controlImg =
                    controlText === "Right"
                      ? require("../Images/drapery/zebra/position_right.svg").default
                      : require("../Images/drapery/zebra/position_left.svg").default;
                } else if (SewingModelId === "0324") {
                  controlImg =
                    controlText === "Right"
                      ? require("../Images/drapery/roller/position_right.svg").default
                      : require("../Images/drapery/roller/position_left.svg").default;
                }
                temp8[controlText] = (
                  <li
                    key={"ControlPosition" + ProductId + i}
                    className={`rmd_info_cp_list_item img_box ${
                      isActiveColor
                        ? isControlSelected && isActiveProduct
                          ? "colorSelected"
                          : ""
                        : "crossed"
                    }`}
                    onClick={() => {
                      if (!isControlSelected) {
                        setIsControlSelected(true);
                      }
                      setSearchParams("?Product=" + obj["ProductId"]);
                    }}
                  >
                    {SewingModelId === "0303" && (
                      <div className="rmd_info_cp_list_item_img_container">
                        <img src={controlImg} className="img-fluid" alt="" />
                        <p className="rmd_info_cp_list_item_img_title">{t(controlText)}</p>
                      </div>
                    )}
                    {SewingModelId === "0324" && (
                      <div className="rmd_info_cp_list_item_container">
                        <div className="rmd_info_cp_list_item_title_container">
                          <p className="rmd_info_cp_list_item_img_title">{t(controlText)}</p>
                        </div>
                        <div className="rmd_info_cp_list_item_img_container">
                          <img src={controlImg} className="img-fluid" alt="" />
                        </div>
                      </div>
                    )}
                    {SewingModelId === "0325" && (
                      <div className="rmd_info_cp_list_item_container">
                        <div className="rmd_info_cp_list_item_img_container">
                          <img src={controlImg} className="img-fluid" alt="" />
                        </div>
                        <div className="rmd_info_cp_list_item_title_container">
                          <p className="rmd_info_cp_list_item_img_title">{t(controlText)}</p>
                        </div>
                      </div>
                    )}
                  </li>
                );
              }

              let promiseArr3 = [];
              if (isActiveProduct) {
                let tempPhotosArr = [
                  obj["Photos"].find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl,
                ];
                tempPhotosArr.push(
                  ...obj["Photos"]
                    .map(function(object) {
                      if (object["PhotoTypeId"] !== 4702 && object["PhotoTypeId"] !== 4709) {
                        return object["PhotoUrl"];
                      } else {
                        return undefined;
                      }
                    })
                    .filter((n) => n)
                );
                tempPhotosArr.forEach((el, j) => {
                  promiseArr3[j] = new Promise((resolve, reject) => {
                    temp3.push(
                      <SplideSlide key={"splide" + ProductId + j} onClick={() => setActiveIndex(j)}>
                        <img
                          className="img-fluid"
                          src={imgUrl(el)}
                          alt={"Image" + j}
                        />
                      </SplideSlide>
                    );
                    temp4.push(
                      <Carousel.Item key={"slide" + obj["ProductId"] + j} className="unselectable">
                        <InnerImageZoom
                          src={imgUrl(el)}
                          zoomSrc={imgUrl(el)}
                          zoomType="none"
                          hideHint={true}
                        />
                      </Carousel.Item>
                    );
                    resolve();
                  });
                });
              }
              Promise.all(promiseArr3).then(() => {
                resolve();
              });
            });
          });
          Promise.all(promiseArr2).then(() => {
            if (isActiveColor && designProducts[key][0]["ProductGroupId"] === "100201") {
              let colorProducts = designProducts[key];
              // Only sizes defined for the selected color
              let colorSizeTexts = [
                ...new Set(
                  colorProducts.map((p) => p["ProductSizeEnName"]).filter(Boolean)
                ),
              ].sort();

              colorSizeTexts.forEach((sizeText) => {
                let sizeVariants = colorProducts.filter(
                  (p) => p["ProductSizeEnName"] === sizeText
                );
                const selectedLiningId = isLiningSelected ? activeProduct["LiningTypeId"] : null;
                const liningMatch =
                  selectedLiningId != null
                    ? sizeVariants.find((p) => p["LiningTypeId"] === selectedLiningId)
                    : null;

                const isSizeCombinationUnavailable =
                  isLiningSelected && selectedLiningId != null && !liningMatch;

                let productForSize = liningMatch
                  ? liningMatch
                  : sizeVariants.find((p) => Number(p["StockQty"]) > 0) || sizeVariants[0];
                let sizeTextFa = productForSize
                  ? productForSize["ProductSizeName"]
                  : sizeText;
                let isSizeActive =
                  isSizeSelected && activeProduct["ProductSizeEnName"] === sizeText;
                let sizeStockQty = liningMatch
                  ? Number(liningMatch["StockQty"]) || 0
                  : sizeVariants.reduce(
                      (max, p) => Math.max(max, Number(p["StockQty"]) || 0),
                      0
                    );
                let isSizeOutOfStock = sizeStockQty === 0;
                temp2[sizeText] = (
                  <li
                    key={"size" + key + sizeText}
                    className={`rmd_info_btn_list_item rmd_lining_style ${
                      isSizeCombinationUnavailable
                        ? "na"
                        : `crossed_selectable ${isSizeOutOfStock ? "crossed" : ""}`
                    } ${isSizeActive && !isSizeCombinationUnavailable ? "btnSelected" : ""}`}
                  >
                    <button
                      type="button"
                      className="btn"
                      disabled={isSizeCombinationUnavailable}
                      title={
                        isSizeCombinationUnavailable
                          ? t("Not made in this combination")
                          : undefined
                      }
                      onClick={() => {
                        if (isSizeCombinationUnavailable) {
                          return;
                        }
                        const match =
                          isLiningSelected && selectedLiningId != null
                            ? colorProducts.find(
                                (p) =>
                                  p["ProductSizeEnName"] === sizeText &&
                                  p["LiningTypeId"] === selectedLiningId
                              )
                            : null;
                        let nextProduct = productForSize;

                        if (!isLiningSelected) {
                          setSecondSelection("size");
                          nextProduct =
                            sizeVariants.find((p) => Number(p["StockQty"]) > 0) ||
                            sizeVariants[0];
                        } else if (secondSelection === "lining") {
                          nextProduct = match || productForSize;
                        } else if (match) {
                          nextProduct = match;
                        } else {
                          setIsLiningSelected(false);
                          nextProduct =
                            sizeVariants.find((p) => Number(p["StockQty"]) > 0) ||
                            sizeVariants[0];
                        }

                        if (!nextProduct) {
                          return;
                        }
                        setSelectedSize(sizeText);
                        setSelectedItems((prev) => ({ ...prev, size: sizeText }));
                        if (!isSizeSelected) {
                          setIsSizeSelected(true);
                        }
                        setSizeError(false);
                        setSearchParams("?Product=" + nextProduct["ProductId"]);
                      }}
                    >
                      {pageLanguage === "fa" ? sizeTextFa : sizeText}
                    </button>
                  </li>
                );
              });

              // Only lining types defined for the selected color
              let liningTypeMap = {};
              colorProducts.forEach((p) => {
                if (p["LiningTypeId"] != null && liningTypeMap[p["LiningTypeId"]] === undefined) {
                  liningTypeMap[p["LiningTypeId"]] = {
                    LiningTypeId: p["LiningTypeId"],
                    LiningTypeName: p["LiningTypeName"],
                    LiningTypeEnName: p["LiningTypeEnName"],
                  };
                }
              });
              let uniqueLiningTypes = Object.values(liningTypeMap).sort(
                (a, b) => a.LiningTypeId - b.LiningTypeId
              );

              if (uniqueLiningTypes.length > 1) {
                let colorSizes = [...new Set(colorProducts.map((p) => p["ProductSizeEnName"]))];
                // Known size: user selected one, or color only has a single size
                let selectedSizeText = isSizeSelected
                  ? selectedSize || activeProduct["ProductSizeEnName"]
                  : colorSizes.length <= 1
                  ? colorSizes[0]
                  : null;

                uniqueLiningTypes.forEach((liningType) => {
                  let liningTypeId = liningType.LiningTypeId;
                  let allLiningVariants = colorProducts.filter(
                    (p) => p["LiningTypeId"] === liningTypeId
                  );
                  let sizeMatch = selectedSizeText
                    ? allLiningVariants.find((p) => p["ProductSizeEnName"] === selectedSizeText)
                    : null;

                  const isLiningCombinationUnavailable =
                    !!selectedSizeText && !sizeMatch;

                  let productForLining =
                    sizeMatch ||
                    allLiningVariants.find((p) => Number(p["StockQty"]) > 0) ||
                    allLiningVariants[0];
                  let liningStockQty = sizeMatch
                    ? Number(sizeMatch["StockQty"]) || 0
                    : allLiningVariants.reduce(
                        (max, p) => Math.max(max, Number(p["StockQty"]) || 0),
                        0
                      );
                  let isLiningOutOfStock = liningStockQty === 0;
                  let liningLabel =
                    pageLanguage === "fa" ? liningType.LiningTypeName : liningType.LiningTypeEnName;
                  let isLiningActive =
                    isLiningSelected && activeProduct["LiningTypeId"] === liningTypeId;

                  temp5[liningTypeId] = (
                    <li
                      key={"lining" + key + liningTypeId}
                      className={`rmd_info_btn_list_item rmd_lining_style ${
                        isLiningCombinationUnavailable
                          ? "na"
                          : `crossed_selectable ${isLiningOutOfStock ? "crossed" : ""}`
                      } ${
                        isLiningActive && !isLiningCombinationUnavailable ? "btnSelected" : ""
                      }`}
                    >
                      <button
                        type="button"
                        className="btn"
                        disabled={isLiningCombinationUnavailable}
                        title={
                          isLiningCombinationUnavailable
                            ? t("Not made in this combination")
                            : undefined
                        }
                        onClick={() => {
                          if (isLiningCombinationUnavailable) {
                            return;
                          }
                          const currentSizeText = isSizeSelected
                            ? selectedSize || activeProduct["ProductSizeEnName"]
                            : null;
                          const match = currentSizeText
                            ? colorProducts.find(
                                (p) =>
                                  p["LiningTypeId"] === liningTypeId &&
                                  p["ProductSizeEnName"] === currentSizeText
                              )
                            : null;
                          let nextProduct = productForLining;
                          let keepSize = false;

                          if (!isSizeSelected) {
                            setSecondSelection("lining");
                            nextProduct =
                              allLiningVariants.find((p) => Number(p["StockQty"]) > 0) ||
                              allLiningVariants[0];
                          } else if (secondSelection === "size") {
                            nextProduct = match || productForLining;
                            keepSize = true;
                          } else if (match) {
                            nextProduct = match;
                            keepSize = true;
                          } else {
                            setIsSizeSelected(false);
                            setSelectedSize(null);
                            setSelectedItems((prev) => ({ ...prev, size: null }));
                            nextProduct =
                              allLiningVariants.find((p) => Number(p["StockQty"]) > 0) ||
                              allLiningVariants[0];
                          }

                          if (!nextProduct) {
                            return;
                          }
                          if (!isLiningSelected) {
                            setIsLiningSelected(true);
                          }
                          setLiningError(false);
                          if (keepSize && nextProduct["ProductSizeEnName"]) {
                            setSelectedSize(nextProduct["ProductSizeEnName"]);
                            setSelectedItems((prev) => ({
                              ...prev,
                              size: nextProduct["ProductSizeEnName"],
                            }));
                            setSizeError(false);
                          }
                          setSearchParams("?Product=" + nextProduct["ProductId"]);
                        }}
                      >
                        {liningLabel}
                      </button>
                    </li>
                  );
                });
              }
            }
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        setColorsList(temp);
        setSizesList(
          Object.keys(temp2)
            .sort()
            .map((key) => temp2[key])
        );
        setLiningsList(
          Object.keys(temp5)
            .sort((a, b) => Number(a) - Number(b))
            .map((liningKey) => temp5[liningKey])
        );
        setWidthList(Object.values(temp6));
        setLengthList(Object.values(temp7));
        if (Object.keys(temp8).length > 1) {
          setControlsList([temp8["Left"], temp8["Right"]]);
        } else {
          setControlsList(Object.values(temp8));
        }
        setSplidesList(temp3);
        setSlidesList(temp4);
      });
    } else {
      setColorsList([]);
      setSizesList([]);
      setLiningsList([]);
      setWidthList([]);
      setLengthList([]);
      setSlidesList([]);
      setSplidesList([]);
    }
  }


  useEffect(() => {
    renderPageContent();
  }, [activeProduct, isSizeSelected, isLiningSelected, secondSelection]);
  function ContextAwareToggleFilters({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        <button
          className="product_desc_accordion_btn"
          aria-expanded={`${isCurrentEventKey}`}
          type="button"
          onClick={decoratedOnClick}
        >
          <p className="product_desc_accordion_btn_title">
            {isCurrentEventKey ? textOnShow : textOnHide}
          </p>
          <div
            className={
              isCurrentEventKey
                ? "product_accordion_btn_arrow_up img-fluid"
                : "product_accordion_btn_arrow_down img-fluid"
            }
          ></div>
        </button>
      </>
    );
  }

  const joinWaitingList = () => {
    if (!validateWaitlistEmail(waitlistEmail.trim())) {
      setWaitlistEmailError(t("Enter an email address like name@example.com."));
      setWaitlistMessageType("error");
      return;
    }

    setWaitlistEmailError("");
    setWaitlistLoading(true);

    axios
      .post(baseURLJoinWaitingList, {
        ProductId: waitlistSubmitProductId || activeProduct["ProductId"],
        Qty: qty,
        Email: waitlistEmail.trim(),
      })
      .then((response) => {
        setWaitlistLoading(false);
        const apiMessage =
          response.data?.Message ||
          response.data?.Errors?.[0]?.Message ||
          "";

        if (response.data?.Success === false || isAlreadyRegisteredMessage(apiMessage)) {
          setWaitlistEmailError(
            t("You have already registered for a notification for this item.")
          );
          setWaitlistMessageType("error");
          return;
        }

        setWaitlistRegisteredEmail(waitlistEmail.trim());
        setModals((prev) => ({
          ...prev,
          waitlist: false,
          waitlist_success: true,
        }));
        setWaitlistEmailError("");
      })
      .catch((err) => {
        console.log(err);
        setWaitlistLoading(false);
        const apiMessage =
          err.response?.data?.Message ||
          err.response?.data?.Errors?.[0]?.Message ||
          "";

        if (isAlreadyRegisteredMessage(apiMessage) || err.response?.data?.Success === false) {
          setWaitlistEmailError(
            t("You have already registered for a notification for this item.")
          );
          setWaitlistMessageType("error");
          return;
        }

        setWaitlistEmailError(apiMessage || t("Please enter a valid email"));
        setWaitlistMessageType("error");
      });
  };

  function updateSideCartSummary(cartObjects) {
    if (!cartObjects || !Object.keys(cartObjects).length) {
      setSideCartProductTotal(0);
      setSideCartInstallPrice(0);
      setSideCartTransportPrice(0);
      setSideCartHasSwatches(false);
      return;
    }

    if (isLoggedIn && cartObjects["CartDetails"]) {
      setSideCartProductTotal(cartObjects["TotalAmount"] || 0);
      setSideCartInstallPrice(cartObjects["InstallAmount"] || 0);
      setSideCartTransportPrice(cartObjects["TransportationAmount"] || 0);
      setSideCartHasSwatches(
        cartObjects["CartDetails"].some((item) => item["TypeId"] === 6402)
      );
      return;
    }

    const draperies = cartObjects["drapery"] || [];
    const products = cartObjects["product"] || [];
    const swatches = cartObjects["swatches"] || [];
    let productTotal = 0;
    let installTotal = 0;

    [...draperies, ...products].forEach((item) => {
      const priceToUse =
        item["DiscountedPrice"] !== undefined && item["DiscountedPrice"] !== null
          ? item["DiscountedPrice"]
          : item["Price"];
      productTotal += (priceToUse || 0) * (item["Count"] || 1);
    });

    draperies.forEach((item) => {
      const installAmount = item["InstallAmount"] || 0;
      const windowCount = item["WindowCount"] || item["Count"] || 1;
      installTotal += installAmount * windowCount;
    });

    const transportItem = draperies.find((item) => item["TransportationAmount"] > 0);
    setSideCartProductTotal(productTotal);
    setSideCartInstallPrice(installTotal);
    setSideCartTransportPrice(transportItem ? transportItem["TransportationAmount"] : 0);
    setSideCartHasSwatches(swatches.length > 0);
  }

  const addProduct = async (product, count) => {
    if (!product) {
      setAddingLoading(false);
      return;
    }

    if (product["ProductGroupId"] === "100201") {
      const selectionState = getOneCurtainSelectionState(
        activeProduct,
        catProducts,
        isColorSelected,
        isSizeSelected,
        isLiningSelected
      );
      if (selectionState.needsSizeSelection && !isSizeSelected) {
        setAddingLoading(false);
        return;
      }
      if (selectionState.needsLiningSelection && !isLiningSelected) {
        setAddingLoading(false);
        return;
      }
    } else if (sizesList.length > 1 && selectedSize === null) {
      setAddingLoading(false);
      return;
    }
    if (isLoggedIn) {
      axios
        .post(
          baseURLAddProduct,
          {},
          {
            headers: authHeader(),
            params: {
              productId: product["ProductId"],
              len: product["len"],
              color: product["Color"],
              width: product["Width"],
              count: count,
            },
          }
        )
        .then((response) => {
          setSideCartObjects(response.data || {});
          updateSideCartSummary(response.data || {});
          setCartCount(response.data?.CartDetails?.length || 0);
          modalHandleShow("cart_modal");
          
          setAddingLoading(false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                addProduct(product, count);
              } else {
                addProduct(product, count);
              }
            });
          } else {
            setAddingLoading(false);
          }
        });
    } else {
      let len = product?.len;
      let ProductGroupId = product?.ProductGroupId;
      let ProductId = product?.ProductId;

      if (ProductGroupId === "100605") {
        if (len == null) return;
        try {
          const response = await axios.get(baseURLGetPrice, {
            params: {
              ProductId,
              len,
            },
          });
          product["Price"] = parseInt(response.data);
          product["DiscountedPrice"] = parseInt(response.data);
        } catch (err) {
          console.log(err);
          navigate("/" + pageLanguage);
          return;
        }
      }

      let customPageCart = {};
      product["Count"] = parseInt(count);
      product["len"] = len;
      // product["Length"] =product["len"];
      product["PhotoUrl"] =
        product["Photos"].find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl || "";

      // بررسی کردن سبد خرید در لوکال استورج
      if (localStorage.getItem("cart") === null) {
        let newCartObj = {};
        let newCartArr = [];
        newCartArr[0] = product;
        newCartObj["drapery"] = newCartArr;
        newCartObj["swatches"] = [];
        localStorage.setItem("cart", JSON.stringify(newCartObj));
        customPageCart = newCartObj;
      } else {
        let cartObj = JSON.parse(localStorage.getItem("cart"));

        if (!cartObj["drapery"] || cartObj["drapery"].length === 0) {
          let newCartArr = [];
          newCartArr[0] = product;
          cartObj["drapery"] = newCartArr;
          localStorage.setItem("cart", JSON.stringify(cartObj));
          customPageCart = cartObj;
        } else {
          let tempProjectContainerIndex = cartObj["drapery"].findIndex(
            (obj) =>
              obj["ProductId"] === product["ProductId"] &&
              obj["len"] === product["len"]
          );

          // بررسی ProductGroupId برابر با 100606
          if (product["ProductGroupId"] === 100606) {
            if (tempProjectContainerIndex === -1) {
              cartObj["drapery"].push(product);
            } else {
              cartObj["drapery"][tempProjectContainerIndex]["Count"] += parseInt(count);
              let updatedProduct = cartObj["drapery"].splice(tempProjectContainerIndex, 1)[0];
              cartObj["drapery"].push(updatedProduct);
            }
          } else {
            if (tempProjectContainerIndex !== -1) {
              cartObj["drapery"][tempProjectContainerIndex]["Count"] += parseInt(count);
              cartObj["drapery"][tempProjectContainerIndex]["Price"] = product["Price"];
              cartObj["drapery"][tempProjectContainerIndex]["DiscountedPrice"] =
                product["DiscountedPrice"];
              let updatedProduct = cartObj["drapery"].splice(tempProjectContainerIndex, 1)[0];
              cartObj["drapery"].push(updatedProduct);
            } else {
              cartObj["drapery"].push(product);
            }
          }

          localStorage.setItem("cart", JSON.stringify(cartObj));
          customPageCart = cartObj;
        }
      }

      setSideCartObjects(customPageCart);
      updateSideCartSummary(customPageCart);
      let cartCount = customPageCart["drapery"]?.length || 0;
      setCartCount(parseInt(cartCount) || 0);
      modalHandleShow("cart_modal");
      setAddingLoading(false);
    }
  };

  function saveProduct(product, isCompleted, forceAdd) {
    setShowToast(false);
    if (isLoggedIn) {
      let tempIndex = userFavorites.findIndex(
        (obj) => obj.ProductId === activeProduct["ProductId"] && obj.IsComplete === isCompleted
      );
      // if(!forceAdd && tempIndex>-1 && (userFavorites[tempIndex]["IsComplete"] || !isCompleted)){
      if (!forceAdd && tempIndex > -1) {
        setToastSave(false);
        setRemovingLoading(true);
        removeProject(userFavorites[tempIndex]["FavoriteProductId"]);
      } else {
        setToastSave(true);
        setSavingLoading(true);
        axios
          .get(baseURLSaveProduct, {
            headers: authHeader(),
            params: {
              id: product["ProductId"],
              pageName: catID,
              isComplete: isCompleted,
            },
          })
          .then((response) => {
            setUserFavorites(response.data || []);
            setSavingLoading(false);

            setShowToast(true);
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  saveProduct(product, isCompleted);
                } else {
                  saveProduct(product, isCompleted);
                }
              });
            } else {
              setSavingLoading(false);
            }
          });
      }
    } else {
      setProductAwaitingLogin([product, isCompleted]);
      dispatch({
        type: ShowLogin2Modal,
      });
    }
  }

  function removeProject(id) {
    axios
      .delete(baseURLDeleteFavorite, {
        params: {
          id: id,
        },
        headers: authHeader(),
      })
      .then((response) => {
        // getFavorites();
        setUserFavorites(response.data || []);
        setRemovingLoading(false);
        setShowToast(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              removeProject(id);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          setRemovingLoading(false);
        }
      });
  }

  useEffect(() => {
    if (Object.keys(designProducts).length > 0) {
      const firstKey = Object.keys(designProducts)[0];
      const firstProduct = designProducts[firstKey][0];

      let maxP = firstProduct.Price;
      let minDP = firstProduct.Price;

      Object.keys(designProducts).forEach((key) => {
        designProducts[key].forEach((product) => {
          if (product.Price > maxP) {
            maxP = product.Price;
          }
          if (product.DiscountedPrice < minDP) {
            minDP = product.Price;
          }
        });
      });

      setMaxPrice(maxP);
      setMinDiscountedPrice(minDP);
      renderPageContent();
    }
    if (Object.keys(designProducts).length > 0) {
      let minDP = Infinity; // فرض بر اینکه ابتدا کمترین قیمت را بی‌نهایت قرار می‌دهیم

      Object.keys(designProducts).forEach((key) => {
        designProducts[key].forEach((product) => {
          if (
            product.DiscountedPrice !== null && // مطمئن شوید که DiscountedPrice مقدار معتبر دارد
            product.DiscountedPrice < minDP
          ) {
            minDP = product.DiscountedPrice;
          }
        });
      });

      setMinDiscountedPrice2(minDP !== Infinity ? minDP : null);
    }
  }, [designProducts]);

  useEffect(() => {
    if (catProducts.length) {
      getActiveColorProducts();
    }
    if (isColorSelected) {
      setColorError(false);
    }

    if (isLiningSelected) {
      setLiningError(false);
    }

    if (
      activeProduct["ProductGroupId"] === "100201"
        ? getOneCurtainSelectionState(
            activeProduct,
            catProducts,
            isColorSelected,
            isSizeSelected,
            isLiningSelected
          ).isProductConfigurationComplete
        : !(
            !(isColorSelected || colorsList.length === 1) ||
            !(isSizeSelected || sizesList.length === 1) ||
            !(isWidthSelected || widthList.length === 1) ||
            !(isLengthSelected || lengthList.length === 1) ||
            !(isControlSelected || controlsList.length === 1) ||
            !(isLiningSelected || liningsList.length <= 1)
          )
    ) {
      setIsPageComplete(true);
    } else {
      setIsPageComplete(false);
    }
  }, [
    catProducts,
    searchParams.get("Product"),
    isColorSelected,
    isSizeSelected,
    isWidthSelected,
    isLengthSelected,
    isLiningSelected,
    isControlSelected,
    selectedItems,
    activeProduct["ProductGroupId"],
  ]);

  useEffect(() => {
    if (slidesList.length) {
      setActiveIndex(0);
    }
  }, [slidesList]);

  useEffect(() => {
    if (isLoggedIn && userFavorites.length && productAwaitingLogin.length) {
      saveProduct(productAwaitingLogin[0], productAwaitingLogin[1], true);
      setProductAwaitingLogin([]);
    }
  }, [userFavorites]);

  useEffect(() => {
    if (splideRef.current) {
      splideRef.current.go(activeIndex);
    }
  }, [activeIndex]);

  useEffect(() => {
    if (pageLanguage !== "") {
      getCatProducts();
      window.scrollTo(0, 0);
    }
  }, [pageLanguage, location.pathname]);

  useEffect(() => {
    if (isLoggedIn) {
      getFavorites();
    } else {
      setUserFavorites([]);
    }
  }, [location.pathname, isLoggedIn]);

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }, [location.pathname]);
  
  useEffect(() => {
    setWidth(undefined);
    activeProduct["len"] = undefined;
  }, [location]);

  useEffect(() => {
    axios
    .get(baseURLFreeShipping)
    .then((response) => {
      setFreeShipPrice(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);

  let priceMin = activeProduct["DiscountedPrice"];
  let priceMax = activeProduct["Price"];

  const oneCurtainSelection = getOneCurtainSelectionState(
    activeProduct,
    catProducts,
    isColorSelected,
    isSizeSelected,
    isLiningSelected
  );
  const {
    isOneCurtainProduct,
    hasSingleSizeForColor,
    singleSizeProduct,
    isAllUnlined,
    hasSingleLiningType,
    singleLiningProduct,
    needsLiningSelection,
    needsSizeSelection,
    isSizeRequirementMet,
    isProductConfigurationComplete,
    availableColorSizes,
  } = oneCurtainSelection;

  let displayMinPrice = Infinity;
  let displayMaxPrice = -Infinity;
  let displayMinDisPrice = Infinity;
  let displayMaxDisPrice = -Infinity;

  const colorGroupProducts =
    isOneCurtainProduct && activeProduct["ColorId"] && catProducts.length
      ? catProducts.filter(
          (p) =>
            p["SewingModelId"] === activeProduct["SewingModelId"] &&
            p["ColorId"] === activeProduct["ColorId"]
        )
      : [];
  const colorGroupHasStock = colorGroupProducts.some((p) => Number(p["StockQty"]) > 0);
  const colorGroupAllSoldOut =
    colorGroupProducts.length > 0 &&
    colorGroupProducts.every(
      (p) => Number(p["StockQty"]) === 0 && p["OnBasket"] === false
    );

  const hasPartialPriceFilter =
    !isProductConfigurationComplete &&
    ((needsSizeSelection && isSizeSelected) ||
      (needsLiningSelection && isLiningSelected));

  let priceScopeProducts = colorGroupProducts;
  if (hasPartialPriceFilter && colorGroupProducts.length) {
    priceScopeProducts = colorGroupProducts.filter((p) => {
      if (needsSizeSelection && isSizeSelected) {
        const sizeText = selectedSize || activeProduct["ProductSizeEnName"];
        if (sizeText && p["ProductSizeEnName"] !== sizeText) {
          return false;
        }
      }
      if (needsLiningSelection && isLiningSelected) {
        if (p["LiningTypeId"] !== activeProduct["LiningTypeId"]) {
          return false;
        }
      }
      return true;
    });
  }

  const priceScopeHasStock = priceScopeProducts.some((p) => Number(p["StockQty"]) > 0);
  const priceScopeAllSoldOut =
    priceScopeProducts.length > 0 &&
    priceScopeProducts.every(
      (p) => Number(p["StockQty"]) === 0 && p["OnBasket"] === false
    );

  // Incomplete: Sold Out when every SKU in scope is stock 0 / OnBasket false (or none in stock).
  // Complete: Sold Out when finalized SKU StockQty is 0.
  const oneCurtainShowSoldOutPrice = isOneCurtainProduct
    ? isProductConfigurationComplete
      ? stockQty === 0
      : hasPartialPriceFilter
      ? priceScopeProducts.length === 0 ||
        priceScopeAllSoldOut ||
        !priceScopeHasStock
      : colorGroupAllSoldOut || !colorGroupHasStock
    : false;
  const oneCurtainCartShowsStockState =
    isOneCurtainProduct && isProductConfigurationComplete;
  const oneCurtainCartSoldOutDisabled =
    oneCurtainCartShowsStockState && isSoldOut;

  const sizeLabelShowsWaitlist =
    isWaitlist && (hasSingleSizeForColor || isSizeSelected);
  const liningLabelShowsWaitlist =
    isWaitlist && (hasSingleLiningType || isLiningSelected);
  const isColorEntirelyWaitlist =
    colorGroupProducts.length > 0 &&
    colorGroupProducts.every(
      (p) => Number(p["StockQty"]) === 0 && p["OnBasket"] === true
    );
  const oneCurtainShowJoinWaitlistButton =
    isOneCurtainProduct &&
    (isColorEntirelyWaitlist || sizeLabelShowsWaitlist || liningLabelShowsWaitlist);

  if (isOneCurtainProduct && colorGroupProducts.length) {
    if (isProductConfigurationComplete && stockQty > 0 && activeProduct["Price"] > 0) {
      displayMinPrice = activeProduct["Price"];
      displayMaxPrice = activeProduct["Price"];
      displayMinDisPrice = activeProduct["DiscountedPrice"];
      displayMaxDisPrice = activeProduct["DiscountedPrice"];
    } else if (!isProductConfigurationComplete && !oneCurtainShowSoldOutPrice) {
      const productsForRange = hasPartialPriceFilter
        ? priceScopeProducts
        : colorGroupHasStock
        ? colorGroupProducts
        : [];
      productsForRange.forEach((product) => {
        displayMinPrice = Math.min(displayMinPrice, product.Price);
        displayMaxPrice = Math.max(displayMaxPrice, product.Price);
        displayMinDisPrice = Math.min(displayMinDisPrice, product.DiscountedPrice);
        displayMaxDisPrice = Math.max(displayMaxDisPrice, product.DiscountedPrice);
      });
    }
  }

  function renderOneCurtainPrice() {
    if (oneCurtainShowSoldOutPrice) {
      return (
        <div className="rmd_info_price sold_out_price">{t("Sold Out")}</div>
      );
    }
    if (displayMinPrice === Infinity || displayMaxPrice === -Infinity) {
      return null;
    }
    return (
      <div
        className="rmd_info_price"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <span
          style={displayMinPrice === displayMinDisPrice ? {} : { textDecoration: "line-through" }}
        >
          {displayMinPrice === displayMaxPrice
            ? GetPrice(displayMaxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
            : pageLanguage === "fa"
            ? GetPrice(displayMaxPrice, pageLanguage, t(""), isTabletOrMobile) +
              " - " +
              GetPrice(displayMinPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
            : GetPrice(displayMinPrice, pageLanguage, t(""), isTabletOrMobile) +
              " - " +
              GetPrice(displayMaxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
        </span>
        {displayMinPrice !== displayMinDisPrice && (
          <span style={{ color: "#ca6667" }}>
            {displayMinDisPrice === displayMaxDisPrice
              ? GetPrice(displayMaxDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
              : pageLanguage === "fa"
              ? GetPrice(displayMaxDisPrice, pageLanguage, t(""), isTabletOrMobile) +
                " - " +
                GetPrice(displayMinDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
              : GetPrice(displayMinDisPrice, pageLanguage, t(""), isTabletOrMobile) +
                " - " +
                GetPrice(displayMaxDisPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
          </span>
        )}
        {isProductConfigurationComplete &&
          activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
          <div className="products_list_item_body_desc_more_desc">
            {i18n.language === "en" ? (
              <>
                {activeProduct["DiscountEnName"]}: {activeProduct["DiscountPercent"]}% off
              </>
            ) : (
              <>
                {activeProduct["DiscountName"]} :
                {new Intl.NumberFormat("fa-IR").format(activeProduct["DiscountPercent"])} % تخفیف
              </>
            )}
          </div>
        )}
      </div>
    );
  }

  useEffect(() => {
    if (cartUpdated) {
      if (mainCart && Object.keys(mainCart).length) {
        updateSideCartSummary(mainCart);
        setSideCartObjects(mainCart);
      } else if (!isLoggedIn && localStorage.getItem("cart")) {
        updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
      }
    }
  }, [cartUpdated]);

  useEffect(() => {
    if (!isLoggedIn && modals["cart_modal"] && localStorage.getItem("cart")) {
      updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
    }
  }, [sideCartPrice, modals, isLoggedIn]);

  useEffect(() => {
    if (sideCartObjects.drapery) {
      setCartCount(sideCartObjects.drapery?.length || 0);
    }
  }, [sideCartObjects]);
  return (
    <div
      className={
        `Product_Item_page_container Ready_made_drapery_page_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }` + ` ${location.pathname.split("/")[2]}`
      }
    >
      <div className="breadcrumb_container dir_ltr">
        <Breadcrumb className="breadcrumb">
          <Breadcrumb.Item
            linkAs={Link}
            className="breadcrumb_item"
            linkProps={{ to: "/" + pageLanguage, className: "breadcrumb_item" }}
          >
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item
            linkAs={Link}
            className="breadcrumb_item"
            linkProps={{
              to: "/" + pageLanguage + "/" + location.pathname.split("/")[2] + "/" + catID,
              className: "breadcrumb_item",
              preventScrollReset: true,
            }}
          >
            {CapitalizeAllWords(catObject["EnTitle"])}
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="rmd_product_area_container">
        <div className="rmd_title_mob_container mobile_only">
          <h1 className="rmd_title_mob">
            {pageLanguage === "fa" ? activeProduct["ProductName"] : activeProduct["ProductENName"]}{" "}
            {pageLanguage === "fa"
              ? activeProduct["SewingModelName"]
              : activeProduct["SewingModelEnName"]}
          </h1>
          <h2
            className={`rmd_price_mob ${
              isOneCurtainProduct
                ? oneCurtainShowSoldOutPrice
                  ? "sold_out_price"
                  : ""
                : isSoldOut || isWaitlist
                ? "sold_out_price"
                : ""
            }`}
          >
            {isOneCurtainProduct
              ? renderOneCurtainPrice()
              : isSoldOut || isWaitlist
              ? t("Sold Out")
              : activeProduct["Price"] > 0 &&
                GetPrice(activeProduct["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)}
          </h2>
        </div>
        <div className="rmd_left_side">
          <div className="rmd_sticky">
            <div className="rmd_vertical_carousel">
              <Splide
                ref={splideRef}
                options={{
                  height: "44rem",
                  width: "8rem",
                  rewind: false,
                  rewindByDrag: false,
                  direction: "ttb",
                  gap: "1.5rem",
                  type: "slide",
                  perPage: 5,
                  perMove: 1,
                  arrows: false,
                  pagination: false,
                  wheel: false,
                  updateOnMove: false,
                  focus: 0,
                }}
                aria-label="My Favorite Images"
              >
                {splidesList}
              </Splide>
            </div>
            <div className="rmd_images_container mobile_only">
              {!!slidesList.length && (
                <Carousel
                  variant="dark"
                  interval={null}
                  activeIndex={activeIndex}
                  controls={false}
                  touch={true}
                  onSelect={(eventKey) => setActiveIndex(eventKey)}
                >
                  {slidesList}
                </Carousel>
              )}
            </div>
            <div className="rmd_images_container desktop_only">
              <Carousel
                variant="dark"
                interval={null}
                activeIndex={activeIndex}
                controls={false}
                touch={true}
              >
                {slidesList}
              </Carousel>
            </div>
          </div>
        </div>
        <div className="rmd_right_side rmd_right_side-one">
          <div className="rmd_info_container rmd_info_container_one_curtain">
            <div className="rmd_info_title_container desktop_only">
              <h1 className="rmd_info_title title-rods" style={{ display: "flex", gap: "0.1rem" }}>
                <p>
                  {pageLanguage === "fa"
                    ? activeProduct["ProductName"]
                    : activeProduct["ProductENName"]}
                </p>
                {activeProduct["ProductGroupId"] === "10" && (
                  <p className="rmd_info_title_span">{t("Fabric By The Meter")}</p>
                )}
              </h1>
            </div>
            <>
              {isOneCurtainProduct ? (
                <div className="rmd_info_price_container desktop_only">{renderOneCurtainPrice()}</div>
              ) : isSoldOut || isWaitlist ? (
                <div className="rmd_info_price_container desktop_only">
                  <div className="rmd_info_price sold_out_price">{t("Sold Out")}</div>
                </div>
              ) : (
                <>
                  {!isPriceSelected && (
                    <div
                      className="rmd_info_price"
                      style={{
                        textDecoration: priceMin < priceMax ? "line-through" : "none",
                      }}
                    >
                      {pageLanguage === "en"
                        ? maxPrice > 0 && (
                            <>
                              {minDiscountedPrice === maxPrice ? (
                                GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                              ) : (
                                <div>
                                  <span>
                                    {GetPrice(
                                      minDiscountedPrice,
                                      pageLanguage,
                                      t(""),
                                      isTabletOrMobile
                                    )}
                                  </span>
                                  <span style={{ paddingRight: "0.3rem" }}>-</span>
                                  <span>
                                    {GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                                  </span>
                                </div>
                              )}
                            </>
                          )
                        : maxPrice > 0 && (
                            <>
                              {minDiscountedPrice === maxPrice ? (
                                GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                              ) : (
                                <div>
                                  {GetPrice(
                                    maxPrice,

                                    pageLanguage,
                                    t(""),
                                    isTabletOrMobile
                                  )}
                                  -
                                  {GetPrice(
                                    minDiscountedPrice,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                </div>
                              )}
                            </>
                          )}
                    </div>
                  )}

                  {isPriceSelected && (
                    <div className="rmd_info_price_container desktop_only">
                      <div
                        className="rmd_info_price"
                        style={{
                          textDecoration: priceMin < priceMax ? "line-through" : "none",
                        }}
                      >
                        {priceActive
                          ? GetPrice(priceActive, pageLanguage, t("TOMANS"), isTabletOrMobile)
                          : activeProduct["Price"] > 0 &&
                            GetPrice(
                              activeProduct["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                      </div>
                    </div>
                  )}
                  {IsDiscPriceSelected ? (
                    <>
                      {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                        <div className="products_list_item_body_desc_more_desc">
                          {activeProduct["DiscountedPrice"] > 0 &&
                            GetPrice(
                              activeProduct["DiscountedPrice"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        fontSize: "1.125rem",
                        marginTop: "-0.5rem",
                      }}
                    >
                      {pageLanguage === "en" ? (
                        <>
                          {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                            <div className="products_list_item_body_desc_more_desc">
                              {activeProduct["DiscountedPrice"] > 0 &&
                                GetPrice(minDiscountedPrice2, pageLanguage, t(""), isTabletOrMobile)}
                            </div>
                          )}
                          {priceMin !== priceMax && <span style={{ color: "#ca6667" }}>-</span>}
                          {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                            <div className="products_list_item_body_desc_more_desc">
                              {activeProduct["DiscountedPrice"] > 0 &&
                                GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                            <div className="products_list_item_body_desc_more_desc">
                              {activeProduct["DiscountedPrice"] > 0 &&
                                GetPrice(maxPrice, pageLanguage, t(""), isTabletOrMobile)}
                            </div>
                          )}
                          {priceMin !== priceMax && <span style={{ color: "#ca6667" }}>-</span>}
                          {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                            <div className="products_list_item_body_desc_more_desc">
                              {activeProduct["DiscountedPrice"] > 0 &&
                                GetPrice(
                                  minDiscountedPrice2,
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}

                  {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                    <div className="products_list_item_body_desc_more_desc">
                      {i18n.language === "en" ? (
                        <>
                          {activeProduct["DiscountEnName"]}: {activeProduct["DiscountPercent"]}% off
                        </>
                      ) : (
                        <>
                          {activeProduct["DiscountName"]} :
                          {new Intl.NumberFormat("fa-IR").format(activeProduct["DiscountPercent"])} %
                          تخفیف
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            </>

            <div className="rmd_info_colors_container">
              <div className="rmd_info_little_title_container">
                <h2 className="rmd_info_little_title">{t("Color: ")}</h2>
                {colorError && (
                  <h3 className="rmd_info_little_title error_text">{t("Select a color")}</h3>
                )}
                <h3 className="rmd_info_little_title">
                  {isColorSelected || colorsList.length === 1
                    ? pageLanguage === "fa"
                      ? activeProduct["ColorName"]
                      : capitalizeFirstLetters(activeProduct["ColorEnName"])
                    : ""}
                </h3>
              </div>
              <ul className={colorsList.length > 1 ? "rmd_info_colors_list" : "noDisplay"}>
                {colorsList}
              </ul>
            </div>
            <>
              {widthList.length > 1 && activeProduct["ProductGroupId"] === "10" && (
                <div className="rmd_info_size_container">
                  <div className="rmd_info_little_title_container">
                    <h2 className="rmd_info_little_title">{t("Width: ")}</h2>

                    <h3 className="rmd_info_little_title">
                      {isWidthSelected
                        ? NumToFa(activeProduct["Width"] + t("Measurements CM"), pageLanguage)
                        : ""}
                    </h3>
                  </div>
                  <ul className={widthList.length > 0 ? "rmd_info_btn_list" : "noDisplay"}>
                    {widthList}
                  </ul>
                </div>
              )}
              {activeProduct["ProductGroupId"] === "10" && (
                <RequestFabricSwatches products={designProducts} />
              )}
            </>
            {activeProduct["ProductGroupId"] === "100201" && (
              <>
                {(location.pathname.split("/")[2] !== "Ready-Made-Shade" ||
                  (widthList.length === 1 && lengthList.length === 1)) &&
                  sizesList.length >= 1 && (
                    <div className="rmd_info_size_container">
                      <div className="rmd_info_little_title_container">
                        <h2 className="rmd_info_little_title">{t("Size: ")}</h2>
                        {needsSizeSelection && !isSizeSelected && (
                          <h3 className={`rmd_info_little_title ${sizeError ? "error_text" : ""}`}>
                            {t("Select a size")}
                          </h3>
                        )}

                        <h3 className="rmd_info_little_title">
                          {(hasSingleSizeForColor || isSizeSelected) && (
                            <>
                              {hasSingleSizeForColor
                                ? pageLanguage === "fa"
                                  ? convertToPersian(singleSizeProduct?.["ProductSizeName"])
                                  : singleSizeProduct?.["ProductSizeEnName"]
                                : pageLanguage === "fa"
                                ? convertToPersian(activeProduct["ProductSizeName"])
                                : activeProduct["ProductSizeEnName"]}
                              {isSoldOut
                                ? ` (${t("Sold Out")})`
                                : isWaitlist
                                ? ` (${t("Out of stock. Join the waitlist.")})`
                                : ""}
                            </>
                          )}
                        </h3>
                      </div>
                      <ul
                        className={
                          needsSizeSelection && sizesList.length >= 1
                            ? "rmd_info_btn_list"
                            : "noDisplay"
                        }
                      >
                        {sizesList}
                      </ul>
                      {needsSizeSelection && (
                      <div className="rmd_info_size_guide">
                        <button
                          aria-expanded="false"
                          type="button"
                          className="btn image_plus_text_btn"
                          onClick={() => {
                            modalHandleShow("measurementsHelp");
                          }}
                        >
                          <div className="ruler_img img-fluid" />
                          <p className="text_underline">{t("Measuring Guide")}</p>
                        </button>
                      </div>
                      )}
                    </div>
                  )}
              </>
            )}

            {/* برای طول */}
            {productGroupId === "100605" && (
              <div className="measure_input_container measure_input_container-rod">
                <h1 className="measure_input_label label-length">{t("Length(cm)")}</h1>
                <div className="measure_input_field_container measure_input_field_container-box">
                  <DebounceInput
                    inputRef={(ref) => (inputs.current["len"] = ref)}
                    debounceTimeout={1500}
                    autoComplete="off"
                    placeholder={t("ENTER LENGTH")}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        if (inputs.current["len"]) {
                          inputs.current["len"].focus();
                        }
                      } else if (
                        !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                        e.keyCode !== 8 &&
                        e.keyCode !== 46 &&
                        e.keyCode !== 37 &&
                        e.keyCode !== 39 &&
                        e.keyCode !== 13
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className={
                      "measure_input" +
                      (width !== undefined && (width < 30 || width > 300)
                        ? " measure_input_err"
                        : "")
                    }
                    type="text"
                    name="width"
                    value={NumToFa(`${width || ""}`, pageLanguage)}
                    onChange={(e) => {
                      let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                      newValue = isNaN(newValue) ? "" : newValue;
                      if (
                        newValue &&
                        newValue !== "" &&
                        parseInt(newValue) >= 80 &&
                        parseInt(newValue) <= 340
                      ) {
                        setWidth(parseInt(newValue));
                        activeProduct["len"] = parseInt(newValue);
                      } else {
                        if (newValue === "" || isNaN(parseInt(newValue))) {
                          setWidth(undefined);
                          activeProduct["len"] = undefined;
                        } else {
                          setWidth(parseInt(newValue));
                          activeProduct["len"] = parseInt(newValue); // مقدار عرض جدید
                        }
                      }
                    }}
                  />
                  <div className="measure_input_postfix">{/* {t("cm_label")} */}</div>
                </div>

                <h2
                  style={{ marginLeft: "0.6rem" }}
                  className={`${
                    pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                  }${
                    width !== undefined && (width < 80 || width > 340)
                      ? " measure_input_desc_err"
                      : ""
                  }`}
                >
                  {RangeToFa(`80 - 340`, pageLanguage)} {t("cm_label")}
                </h2>
              </div>
            )}
            {/* اینجا 100611 الکی گذاشته شده تا پرده های رومن شید کار بشه و لاینیگ داشته باشه */}

            {productGroupId === "100201" && !isAllUnlined && (needsLiningSelection || hasSingleLiningType) && (
              <div className="rmd_info_lining_container">
                <div className="rmd_info_little_title_container">
                  <h2 className="rmd_info_little_title">{t("Lining: ")}</h2>
                  {needsLiningSelection && !isLiningSelected && (
                    <h3 className={`rmd_info_little_title ${liningError ? "error_text" : ""}`}>
                      {t("Select a lining")}
                    </h3>
                  )}
                  <h3 className="rmd_info_little_title">
                    {(hasSingleLiningType || isLiningSelected) && (
                      <>
                        {hasSingleLiningType
                          ? pageLanguage === "fa"
                            ? singleLiningProduct?.["LiningTypeName"]
                            : singleLiningProduct?.["LiningTypeEnName"]
                          : pageLanguage === "fa"
                          ? activeProduct["LiningTypeName"]
                          : activeProduct["LiningTypeEnName"]}
                        {isSoldOut
                          ? ` (${t("Sold Out")})`
                          : isWaitlist
                          ? ` (${t("Out of stock. Join the waitlist.")})`
                          : ""}
                      </>
                    )}
                  </h3>
                </div>
                <ul
                  className={
                    needsLiningSelection && liningsList.length >= 1
                      ? "rmd_info_btn_list"
                      : "noDisplay"
                  }
                >
                  {liningsList}
                </ul>
              </div>
            )}

            <div className="rmd_info_qty_container">
              <div className="rmd_info_little_title_container">
                <h2 className="rmd_info_little_title">
                  {productGroupId === "10" ? t("METER(S)") : t("QTY: ")}
                </h2>
                {isOverStock && (
                  <h3 className="rmd_info_little_title error_text">
                    {t("We only have {{count}} QTY available.", {
                      count: NumToFa(stockQty, pageLanguage),
                    })}
                  </h3>
                )}
              </div>
              <span className="basket_item_qty">
                <QtyCountFabric
                  qty={qty}
                  setQty={setQty}
                  minQty={1}
                  maxQty={fabricMaxQty}
                  steps={fabricSteps}
                  isReadOnly={true}
                  disabled={isSoldOut || isWaitlist}
                  pageLanguage={pageLanguage}
                  NumberToPersianWord={NumberToPersianWord}
                />
              </span>
            </div>

            <div className="rmd_info_btn_container bag_buttons_section_container">
              <div className="join_waitlist_action_block">
                <button
                  className={`btn add_to_cart${
                    oneCurtainCartSoldOutDisabled ? " add_to_cart_sold_out_keep_style" : ""
                  }`}
                  onClick={async () => {
                    if (isOneCurtainProduct) {
                      if (oneCurtainShowJoinWaitlistButton) {
                        openWaitlistModal();
                        return;
                      }
                      if (needsSizeSelection && !isSizeSelected) {
                        setSizeError(true);
                        return;
                      }
                      if (needsLiningSelection && !isLiningSelected) {
                        setLiningError(true);
                        return;
                      }
                      if (oneCurtainCartShowsStockState && (isSoldOut || isOverStock)) {
                        return;
                      }
                      if (oneCurtainCartShowsStockState && isWaitlist) {
                        openWaitlistModal();
                        return;
                      }
                    } else {
                      if (isSoldOut || isOverStock) return;
                      if (isWaitlist) {
                        openWaitlistModal();
                        return;
                      }
                    }
                    if (
                      activeProduct["ProductGroupId"] !== "100201" &&
                      selectedSize === null &&
                      sizesList.length > 1
                    ) {
                      setSizeError(true);
                      setLiningError(true);
                      return;
                    }

                    setAddingLoading(true);
                    let filteredProduct = null;
                    const targetProductId = isProductActive ?? searchParams.get("Product");
                    Object.keys(designProducts).forEach((key) => {
                      designProducts[key].forEach((item) => {
                        if (item.ProductId === targetProductId) {
                          filteredProduct = item;
                        }
                      });
                    });

                    if (!filteredProduct && activeProduct?.["ProductId"]) {
                      filteredProduct = activeProduct;
                    }

                    addProduct(filteredProduct, qty);
                  }}
                  disabled={
                    (isOneCurtainProduct
                      ? oneCurtainCartShowsStockState && (isSoldOut || isOverStock)
                      : isSoldOut || isOverStock) ||
                    addingLoading ||
                    savingLoading ||
                    removingLoading ||
                    waitlistLoading
                  }
                >
                  {isOneCurtainProduct && oneCurtainShowJoinWaitlistButton
                    ? waitlistLoading
                      ? t("ADDING...")
                      : t("JOIN WAITLIST")
                    : isOneCurtainProduct && !oneCurtainCartShowsStockState
                    ? addingLoading
                      ? t("ADDING...")
                      : t("footer_Add To Cart")
                    : isSoldOut
                    ? t("Sold Out")
                    : isOverStock
                    ? t("NOT AVAILABLE")
                    : isWaitlist
                    ? waitlistLoading
                      ? t("ADDING...")
                      : t("JOIN WAITLIST")
                    : ((activeProduct["ProductGroupId"] === "100201" &&
                        isProductConfigurationComplete) ||
                        (activeProduct["ProductGroupId"] !== "100201" &&
                          selectedSize !== null)) &&
                      addingLoading
                    ? t("ADDING...")
                    : t("footer_Add To Cart")}
                </button>
                {isWaitlist && waitlistEmailError && (
                  <div
                    className={`join_waitlist_message ${
                      waitlistMessageType === "success"
                        ? "join_waitlist_message_success"
                        : "join_waitlist_message_error"
                    } ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
                  >
                    {waitlistEmailError}
                  </div>
                )}
              </div>
              <button
                className="save_to_acc white_btn btn"
                onClick={() => {
                  if (isPageComplete) {
                    saveProduct(activeProduct, true);
                  } else {
                    saveProduct(activeProduct, false);
                  }
                }}
                disabled={addingLoading || savingLoading || removingLoading || waitlistLoading}
              >
                <img
                  src={
                    userFavorites.findIndex(
                      (obj) =>
                        obj.ProductId === activeProduct["ProductId"] &&
                        obj.IsComplete === isPageComplete
                    ) > -1
                      ? require("../Images/public/favorite_filled.png")
                      : require("../Images/public/favorite.png")
                  }
                  className="img-fluid"
                  alt=""
                />
                {savingLoading
                  ? t("SAVING...")
                  : removingLoading
                  ? t("REMOVING...")
                  : t("product_Save_To_wishlist")}
              </button>
            </div>
            <div className="rmd_info_desc_container">
              <Accordion>
                <Accordion.Item eventKey="0">
                  <ContextAwareToggleFilters
                    eventKey="0"
                    textOnHide={t("Product Description")}
                    textOnShow={t("Product Description")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["DescriptionEn"]
                          : convertToPersian(activeProduct["Description"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Dimensions")}
                    textOnShow={t("Dimensions")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["DimensionEn"]
                          : convertToPersian(activeProduct["Dimension"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <ContextAwareToggleFilters
                    eventKey="2"
                    textOnHide={t("Materials & Care")}
                    textOnShow={t("Materials & Care")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["MatrialCareEn"]
                          : convertToPersian(activeProduct["MatrialCare"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <ContextAwareToggleFilters
                    eventKey="3"
                    textOnHide={t("Shipping & Returns")}
                    textOnShow={t("Shipping & Returns")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["ShippingReturnEn"]
                          : convertToPersian(activeProduct["ShippingReturn"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
        }}
        id="cart_modal"
      >
        <div className="custom_cart_header_desc">{`${
          freeShipPrice - sideCartPrice > 0
            ? `${t("cart_agree_free_ship1")}${
                pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(
                      `${GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )}`
                    )
                  : GetPrice(
                      freeShipPrice - sideCartPrice,
                      pageLanguage,
                      t("TOMANS"),
                      isTabletOrMobile
                    )
              }${t("cart_agree_free_ship2")}`
            : `${t("cart_agree_free_ship")}`
        }`}</div>
        <Modal.Header>
          <span className="custom_cart_title">
            {t("My Bag")}{" "}
            <h3>
              (
              {pageLanguage === "fa"
                ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                : cartCount}
              )
            </h3>
          </span>
          <button
            className="custom_cart_close"
            onClick={() => {
              modalHandleClose("cart_modal");
              sessionStorage.clear();
              // navigate("/" + pageLanguage);
            }}
          >
            {t("CONTINUE SHOPPING")}
          </button>
        </Modal.Header>
        <Modal.Body>
          <RenderSideCart cartObjects={sideCartObjects} setCartCount={setCartCount} />
        </Modal.Body>
        <Modal.Footer>
          <div className="go_to_checkout" style={{backgroundColor: "#faf9f7"}}>
            <div className="checkout_button_section small_checkout_button_section">
              <div className="small_cart_price_summary">
                {
                  sideCartProductTotal > 0 && (
                    <span className="checkout_payment_price_detail payment_price_detail" style={{marginTop:"0.7rem"}}>
                  <h3>{t("PRODUCT TOTAL")}</h3>
                  <h4>
                    {GetPrice(sideCartProductTotal, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                  </h4>
                </span>
                  )
                }
               
                {sideCartInstallPrice > 0 && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("INSTALLATION SERVICES")}</h3>
                    <h4>
                      {GetPrice(sideCartInstallPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                    </h4>
                  </span>
                )}
                {sideCartTransportPrice > 0 && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("TRANSPORTATION FEE")}</h3>
                    <h4>
                      {GetPrice(
                        sideCartTransportPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )}
                    </h4>
                  </span>
                )}
                {(sideCartHasSwatches ||
                  sideCartProductTotal > 0 ||
                  sideCartInstallPrice > 0 ||
                  sideCartTransportPrice > 0) && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("SHIPPING")}</h3>
                    <h4>
                      {freeShipPrice > 0 &&
                      (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                        ? t("FREE")
                        : t("CALCULATED AT CHECKOUT")}
                    </h4>
                  </span>
                )}
              </div>
              <span className="checkout_payment_price_detail payment_price_detail small_cart_subtotal">
              <h3>
                 {freeShipPrice > 0 &&
                (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                 ? t("TOTAL")
               : t("SUBTOTAL")}
              </h3>
                <h4>
                  {GetPrice(
                    isLoggedIn
                      ? sideCartPrice
                      : sideCartProductTotal + sideCartInstallPrice + sideCartTransportPrice,
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  )}
                </h4>
              </span>
              <Link className="basket_checkout btn" to={"/" + pageLanguage + "/Basket"}>
                {t("CHECKOUT")}
              </Link>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`measurementsHelp_modal largeSizeModal scroll_on ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["measurementsHelp"] === undefined ? false : modals["measurementsHelp"]}
        onHide={() => modalHandleClose("measurementsHelp")}
        scrollable={true}
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <StaticMeasureHelps SewingModelId={activeProduct["SewingModelId"]} />
          <div className="text_center">
            <button
              className="btn btn-new-dark"
              onClick={() => modalHandleClose("measurementsHelp")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <WaitlistModalOneCurtain
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
        activeProduct={activeProduct}
        designProducts={designProducts}
        selectedSize={selectedSize}
        isSizeSelected={isSizeSelected}
        isLiningSelected={isLiningSelected}
        hasSingleSizeForColor={hasSingleSizeForColor}
        hasSingleLiningType={hasSingleLiningType}
        waitlistEmail={waitlistEmail}
        setWaitlistEmail={setWaitlistEmail}
        waitlistEmailError={waitlistEmailError}
        setWaitlistEmailError={setWaitlistEmailError}
        waitlistLoading={waitlistLoading}
        onSubmitWaitlist={joinWaitingList}
        onWaitlistProductChange={handleWaitlistProductChange}
      />

      <WaitlistSuccessModalOneCurtain
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
        activeProduct={activeProduct}
        registeredEmail={waitlistRegisteredEmail}
      />

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["add_to_project_modal"] === undefined ? false : modals["add_to_project_modal"]}
        onHide={() => {
          modalHandleClose("add_to_project_modal");
        }}
        id="add_to_project_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="add_to_project_container">
            <h2 className="project_added_text">{t("1 ITEM ADDED TO YOUR FAVORITES")}</h2>
            <Link className="add_to_project_btn btn" to={"/" + pageLanguage + "/Account/Favorites"}>
              {t("VIEW FAVORITES")}
            </Link>
            <button
              className="continue_shopping_btn"
              onClick={() => {
                modalHandleClose("add_to_project_modal");
              }}
            >
              {t("CONTINUE SHOPPING")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer
        className={`position_fixed favorite_saved ${toastSave ? "" : "favorite_removed"}`}
        position="top-end"
      >
        <Toast
          onClose={() => setShowToast(false)}
          bg="Light"
          show={showToast}
          delay={5000}
          autohide
        >
          <Toast.Body>
            <div className="favorite_toast_container">
              <div className="favorite_toast_title">
                {toastSave ? t("Added to Favorites") : t("Removed from Favorites")}
              </div>
              <div className="favorite_toast_details">
                <img
                  src={imgUrl(activeProduct["Photos"]?.find(
                    (obj) => obj.PhotoTypeId === 4709
                  )?.PhotoUrl || "")}
                  alt=""
                  className="favorite_toast_img img-fluid"
                />
                <div className="favorite_toast_name">
                  {pageLanguage === "fa"
                    ? activeProduct["ProductName"]
                    : activeProduct["ProductENName"]}{" "}
                  {pageLanguage === "fa"
                    ? activeProduct["SewingModelName"]
                    : activeProduct["SewingModelEnName"]}
                </div>
              </div>
              <div className="button_section">
                <Link className="save_to_fav white_btn " to={"/" + pageLanguage + "/Favorites"}>
                  {t("VIEW FAVORITES")}
                </Link>
              </div>
            </div>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}

export default ReadyMyProduct;
